/** See `src/i18n/locales/en/reports.ts`. */
export const reports = {
  page: {
    title: 'Rapportages',
    lead: 'Rapportages voor {{company}}, opgebouwd uit bestaande data — er wordt geen aparte rapportdata opgeslagen.',
    noScope: 'Selecteer een bedrijf om de rapportages te zien.',
    forbidden: 'Je mag de rapportages van dit bedrijf niet zien.',
  },
  library: {
    title: 'Rapportbibliotheek',
  },
  cards: {
    vitaliteitstrends: {
      title: 'Maandelijkse vitaliteitstrends',
      description: 'Totaal aantal stappen per maand, bedrijfsbreed.',
    },
    deelnamerapport: {
      title: 'Deelnamerapport',
      description: 'Hoeveel medewerkers actief zijn, en hoe recent.',
    },
    'challenge-resultaten': {
      title: 'Challenge-resultaten',
      description: 'Challenges per status en gemiddelde voortgang van deelnemers.',
    },
    communicatiebereik: {
      title: 'Communicatiebereik',
      description: 'Verzonden, afgeleverde en geopende notificaties.',
    },
    documentgebruik: {
      title: 'Documentgebruik',
      description: 'Gepubliceerde/gearchiveerde documenten en hun totaal aantal weergaven.',
    },
  },
  actions: {
    exportCsv: 'Exporteer CSV',
    exportPdf: 'Exporteer PDF',
  },
  export: {
    pdfFallbackNote:
      'PDF-export is nog niet beschikbaar — er is in plaats daarvan een CSV-bestand gedownload.',
    error: 'Dit rapport kon niet worden geëxporteerd.',
  },
} as const;
